module.exports = __webpack_public_path__ + "assets/img/图层 15.464aed82.png";